<template>
  <div>
    <div class="app-header flex-x-center flex-space-between">
      <img src="@/assets/img/bi_order_app_v.png" class="app-header-bi">
    </div>
    <div class="noFranchisee">
      <div class="ComingSoonImg"></div>
      <p>상점이 오픈 준비중입니다.<br>조금만 기다려주세요!</p>
    </div>
    <div class="ComingSoonBtn" @click="move" v-if="groupQr || appFlag">확인</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      categoryCode: '',
      addressByLotNum: ''
    }
  },
  mounted () {
    this.appCateAddrSet()
  },
  computed: {
    groupQr () {
      return !!sessionStorage.getItem('GroupQrData')
    }
  },
  methods: {
    move () {
      if (this.groupQr) {
        this.goStoreList()
      }
      if (this.appFlag) {
        this.closeOrderApp()
      }
    },
    goStoreList () {
      this.$router.push({
        name: 'AppStoreList',
        query: {
          // categoryCode: this.$route.query.categoryCode, // 음식 카테고리 코드
          // addressByLotNum: this.$route.query.addressByLotNum // 지번주소
          categoryCode: this.groupQr ? this.$route.query.categoryCode : this.categoryCode,
          addressByLotNum: this.groupQr ? this.$route.query.addressByLotNum : this.addressByLotNum
        }
      })
    },
    appCateAddrSet () {
      this.categoryCode = sessionStorage.getItem('categoryCode')
      this.addressByLotNum = sessionStorage.getItem('addressByLotNum')
    }
  }
}
</script>

<style scoped>
</style>
